import {SidebarSection} from './SidebarSection'
import styles from './Reviewers.module.css'

/** Reviewers section in the sidebar */
export function Reviewers() {
  return (
    <SidebarSection title="Reviewers">
      <ul className={styles.reviewerList}>
        <ReviewerRow name="Copilot" statusLabel="Commented" />
        <ReviewerRow name="torvalds" statusLabel="Approved" />
        <ReviewerRow name="security-reviewers" statusLabel="Pending" />
      </ul>
    </SidebarSection>
  )
}

interface ReviewerRowProps {
  name: string
  statusLabel: string
}

function ReviewerRow({name, statusLabel}: ReviewerRowProps) {
  return (
    <li className={styles.reviewerRow}>
      <span className={styles.avatar} />
      <span className={styles.reviewerName}>{name}</span>
      <span className={styles.reviewerStatus}>{statusLabel}</span>
    </li>
  )
}
